import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_TO_DEMO_4 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `But Turf Optimization doesn't stop there. It \nintroduces real-time travel time metrics. \nThese meticulous details empower a \nwealth of knowledge, enabling strategic \ndecisions that <span style="color: #BEE3FF;">not only enhance efficiency \nbut also optimize response times and \nthere by improves customer satisfaction \nas well.</span>`,
  subtitle: "turf optimization DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(409),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(407),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "TURF_OPTIMIZATION/TO_bg_4.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "TURF_OPTIMIZATION/TO_DEMO_4_1.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "TURF_OPTIMIZATION/TO_DEMO_4_2.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
      ]}
      pageNumber={408}
    />
  ),
};
